// extracted by mini-css-extract-plugin
export const button = "button-module--button--3HOie";